import { render, staticRenderFns } from "./LeftDropdown.vue?vue&type=template&id=023f3502&scoped=true&"
import script from "./LeftDropdown.vue?vue&type=script&lang=ts&"
export * from "./LeftDropdown.vue?vue&type=script&lang=ts&"
import style0 from "./LeftDropdown.vue?vue&type=style&index=0&id=023f3502&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023f3502",
  null
  
)

export default component.exports